// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","364":"winner","445":"person","660":"winners","826":"index"}[chunkId] + "." + {"177":"4116dc76","364":"3f353c4a","445":"31259c94","660":"838fe025","826":"63f9013a"}[chunkId] + ".css";
};